import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { ClothListTableDataColumnType, ClothListTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import api from "../../../utils/api";
import Swal from "sweetalert2";

export const clothListData = [
    {
      "clothId": 1,
      "clothQuantity": 10,
      "clothImage": "645080c3-fce0-45f6-bf56-d791763d6f65.webp",
      "clothSize": "Small",
      "clothPrice": 1000,
      "isLocked": true,
      "gender": 1
    },
    {
      "clothId": 2,
      "clothQuantity": 10,
      "clothImage": "e6ff2392-b74d-475f-89db-019ed70f0adc.jpg",
      "clothSize": "Medium",
      "clothPrice": 1000,
      "isLocked": true,
      "gender": 2
    },
  ];

// const ClothListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this cloth!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
               confirmDelete(id);
            }
        });
    };

    const confirmDelete = async (id: number) => {
        try {
            await api.delete(`/api/ClothMaster/DeleteClothMaster?clothId=${id}`);
            Swal.fire('Deleted!', 'Cloth has been deleted.', 'success');
        
            // Optional: refresh the list
            // setClothListTableDatas((prev) => prev.filter((item: { clothId: any; }) => item.clothId !== id));
        } catch (error) {
            Swal.fire('Error!', 'Failed to delete the cloth.', 'error');
            console.error("Delete error:", error);
        }
    }

interface ProductListTableActionProps {
  clothId: any;
  onDelete: (id: number) => void;
}

export const ClothListTableAction: React.FC<ProductListTableActionProps> = ({ clothId, onDelete }) => {
  const editUrl = `/coupon/edit/${clothId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this offer!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(clothId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link>
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};


export const ClothListTableOfferComponent: React.FC<ClothListTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const ClothListTableStatus :React.FC<ClothListTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export  const ClothListTableDataColumn: TableColumn<ClothListTableDataColumnType>[] = [
      {
      name: "Id",
      cell: (row: any) => <ClothListTableOfferComponent title={row.clothId} />,
      sortable: true,
      grow: 2,
      },
      {
        name: "Cloth Quantity",
        cell: (row) => <ClothListTableOfferComponent title={String(row.clothQuantity)} />,
        sortable: true,
        grow: 2,
      },
      {
        name: "Cloth Size",
        cell: (row) => <ClothListTableOfferComponent title={row.clothSize} />,
        sortable: true,
        grow: 2,
      },
      {
        name: "Gender",
        cell: (row) => <ClothListTableOfferComponent title={String(row.gender)} />,
        sortable: true,
        grow: 2,
      },
      {
        name: "Cloth Price",
        cell: (row) => <ClothListTableOfferComponent title={String(row.clothPrice)} />,
        sortable: true,
        grow: 2,
      },
      {
        name: "Security Charge",
        cell: (row) => <ClothListTableOfferComponent title={String(row.securityCharges)} />,
        sortable: true,
        grow: 2,
      },
      {
        name: "Cloth Status",
        cell: (row) => <ClothListTableStatus title={String(row.isLocked)} />,
      },
      {
        name: "Action",
        cell: (row) => <ClothListTableAction clothId={row.clothId} onDelete={handleDelete} />,
      },
];

  export const filtersData = [
    {
      name: "Choose Title",
      options: ["Adult", "Child"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];